import loadable from '@loadable/component';

export const MozoSiteWrapper = loadable(
  () => import(/* webpackChunkName: "mozo-site" */ './MozoSiteWrapper'),
);
